import React from 'react';
import { ClockIcon, BellIcon, CheckCircleIcon, ZapIcon } from 'lucide-react';
import { openCalendlyPopup } from '../utils/calendly';
import { useLanguage } from '../contexts/LanguageContext';
export function PriorisierungSection() {
  const {
    t
  } = useLanguage();
  const features = [{
    icon: ZapIcon,
    title: t('prio.realtime.title'),
    description: t('prio.realtime.desc')
  }, {
    icon: BellIcon,
    title: t('prio.followup.title'),
    description: t('prio.followup.desc')
  }, {
    icon: CheckCircleIcon,
    title: t('prio.focus.title'),
    description: t('prio.focus.desc')
  }, {
    icon: ClockIcon,
    title: t('prio.time.title'),
    description: t('prio.time.desc')
  }];
  return <section className="py-16 lg:py-24 bg-[#0d1225]" data-id="element-226">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16" data-id="element-228">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-229">
            {t('prio.title')}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-230">
            {t('prio.subtitle')}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8" data-id="element-231">
          {features.map((feature, index) => <div key={index} className="bg-gradient-to-br from-[#1a1f36] to-[#111827] rounded-xl border border-white/5 p-6 lg:p-8 hover:border-[#ff6b35]/30 transition-colors" data-id="element-232">
              <div className="w-12 h-12 bg-[#ff6b35]/10 rounded-lg flex items-center justify-center mb-4" data-id="element-233">
                <feature.icon className="w-6 h-6 text-[#ff6b35]" data-id="element-234" />
              </div>
              <h3 className="text-xl font-semibold text-white mb-3" data-id="element-235">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-236">
                {feature.description}
              </p>
            </div>)}
        </div>

        {/* CTA */}
        <div className="text-center mt-12" data-id="element-237">
          <button onClick={openCalendlyPopup} className="inline-flex items-center gap-2 bg-[#ff6b35] hover:bg-[#ff5722] text-white px-8 py-4 rounded-lg font-semibold transition-colors" data-id="element-238">
            {t('prio.cta')}
          </button>
        </div>
      </div>
    </section>;
}